<template>
  <Container tagName="section" class="ProductHowToBuyContainer">
    <div class="ProductHowToBuy">
      <h2 v-if="content.heading" class="heading">{{ content.heading }}</h2>

      <div class="tabWrapper">
        <button
          v-if="content.hasBusiness && content.businessHeading"
          class="tabButton"
          :class="currentTab === 'business' && 'active'"
          @click="currentTab = 'business'"
        >
          {{ content.businessHeading }}
        </button>
        <button
          v-if="content.hasPersonal && content.personalHeading"
          class="tabButton"
          :class="currentTab === 'personal' && 'active'"
          @click="currentTab = 'personal'"
        >
          {{ content.personalHeading }}
        </button>
      </div>

      <div class="tabPanes">
        <div
          v-if="content.hasBusiness"
          class="tabPane"
          :class="currentTab === 'business' && 'active'"
        >
          <DefaultBlockContent v-if="content.businessBody" :blocks="content.businessBody" class="body" />
          <div v-if="content.businessCta" class="ctaWrapper">
            <CtaButton class="--bright-blue" icon="arrow" v-bind="content.businessCta" />
          </div>
        </div>
        <div
          v-if="content.hasPersonal"
          class="tabPane"
          :class="currentTab === 'personal' && 'active'"
        >
          <DefaultBlockContent v-if="content.personalBody" :blocks="content.personalBody" class="body" />
          <div class="carriers">
            <template v-for="item in content.carriers">
              <a v-if="item.url" :href="item.url" target="_blank" :key="item._key" class="carrier">{{ item.title }}</a>
            </template>
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import DefaultBlockContent from '../elems/DefaultBlockContent.vue'

export default {
  components: {
    DefaultBlockContent,
  },
  props: {
    content: Object,
  },
  data() {
    return {
      currentTab: null,
    }
  },
  created() {
    this.setInitialTab();
  },
  methods: {
    setInitialTab() {
      if (this.content.hasBusiness) {
        this.currentTab = 'business';
      } else if (this.content.hasPersonal) {
        this.currentTab = 'personal';
      } else {
        this.currentTab = null;
      }
    },
  },
}
</script>

<style scoped>
  .ProductHowToBuyContainer {
    background-color: var(--bg-color-pale-gray);
    color: var(--text-color-dark);
  }
  .ProductHowToBuy {
    padding-top: var(--spacing-8);
    padding-bottom: var(--spacing-15);
  }
  .heading {
    color: var(--text-color-black);
    font-weight: 600;
    font-size: var(--font-size-8);
    line-height: 1.2;
    margin-bottom: var(--spacing-12);
  }

  .tabWrapper {
    border-bottom: 1px solid #cbcbcb;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: var(--spacing-17);
    margin-bottom: var(--spacing-9);
  }

  .tabButton {
    font-weight: 600;
    font-size: var(--font-size-5);
    padding: 0 4px var(--spacing-3);
    color: var(--text-color-dark);
    border-bottom: 3px solid transparent;
  }
  .tabButton.active {
    color: var(--brand-color);
    border-bottom: 3px solid var(--brand-color);
  }

  .tabPane {
    display: none;
  }
  .tabPane.active {
    display: block;
  }

  .body {
    font-weight: normal;
    font-size: var(--font-size-3);
    line-height: 1.7;
  }
  .body:deep(p) + p {
    margin-top: var(--spacing-6);
  }
  .body + .ctaWrapper {
    margin-top: var(--spacing-8);
  }

  .carriers {
    margin-top: var(--spacing-8);
  }
  .carrier {
    display: block;
    color: var(--brand-color);
    text-decoration: underline;
    font-weight: normal;
    font-size: var(--font-size-3);
    line-height: 1.7;
  }
</style>
